<script setup lang="ts">
const windowScroll = useWindowScroll();
const modalsStore = useModalsStore();
const device = useDevice();

const data = [
    {
        name: 'ناصرعلی سعادت',
        role: 'مدیر عامل، کیت لاین',
        img: '/img/new/comments/kit-line.webp',
        desc: 'در دسترس بودن تمامی همکاران، حذف سیستم تلفن سانترال، عدم نیاز به گوشی تلفن و استفاده از موبایل، امکان پاسخگویی در تمامی ساعت ها که تمامی آیتم ها باعث افزایش رضایت کارکنان شرکت و همچنین مشتریان شده است.\nپاسخگویی سریع و پیگیری پشتیبانی تیم فنی در کوتاه ترین زمان و رفع مشکلات و ارائه مشاوره‌های تخصصی نیز از نقاط قوت نواتل است.',
        product: 'همه محصولات',
    },
    {
        name: 'محمدرضا نوری',
        role: 'مدیر اجرایی، انتشارات کتابچی',
        img: '/img/new/comments/ketabchi.webp',
        desc: 'از خدمات ارزشمند تیم شما صمیمانه سپاسگزارم. کیفیت تماس‌ها و ارتباط سریع و آسان با مشتریان، همراه با امکان ارسال پیامک‌های راحت، تجربه‌ای بی‌نظیر و بدون دغدغه برای مجموعه کتابچی ایجاد کرد. حتماً این همکاری را به دیگران نیز توصیه خواهم کرد. موفق و پیروز باشید.',
        product: 'مرکز تلفن ابری، سی آر ام ابری، پنل پیامکی',
    },
    {
        name: 'امیرعلی پورکیان',
        role: 'مدیر کل، موتوری 24',
        img: '/img/new/comments/motori-24.webp',
        desc: 'درود خدمت عزیزان. \nنواتل فضای بسیار عالی و راحتی برای برقراری ارتباط با مشتری , CRM , انبار و محصولات و صدور فاکتور رو داره و محاسبات سیستمیه عالی هم داره و همچنین پیگیری کارشناسان محترم هم جز نقاط قوت این مجموعه هست. ممنون از تیم نواتل🌷',
        product: 'همه محصولات',
    },
];
const parent = useTemplateRef('parent');
const content = useTemplateRef('content');
const parentOffset = useElementBounding(parent);
const topIndicate = 132;

const startFixing = computed(() => {
    if (
        !windowScroll.y 
        || !device.isDesktop.value
        || !content.value 
        || !parentOffset.bottom.value 
        || !parentOffset.top.value
    ) return;

    return parentOffset.bottom.value > content.value.offsetHeight + topIndicate
        && parentOffset.top.value < topIndicate;
});

const endFixing = computed(() => {
    if (
        !windowScroll.y 
        || !device.isDesktop.value
        || !content.value 
        || !parentOffset.bottom.value
    ) return;

    return parentOffset.bottom.value < content.value.offsetHeight + topIndicate;
});

function handleOpenModal() {
    modalsStore.openModal('CTA');
};
</script>

<template>
    <SectionsBase
        id="comments" 
        class="bg-linear-to-b from-primary-50 to-secondary-50 relative scroll-m-25!"
    >
        <div ref="parent" class="container relative z-1 flex flex-col lg:flex-row lg:justify-end">
            <div
                ref="content"
                class="lg:absolute lg:top-0 lg:inset-x-0"
                :class="[
                    startFixing && !endFixing && 'lg:fixed lg:top-32',
                    endFixing && 'lg:top-auto! lg:bottom-0!'
                ]"
            >
                <div :class="device.isDesktop.value && 'container'">
                    <ChipsBase type="Secondary" variant="warning" class="mb-8">نظرات مشتریان</ChipsBase>
                    <h2 class="text-start relative">
                        <IconsFlash class="absolute -top-7 right-52 lg:right-72" />
                        <span>تجربه کسب‌وکارها از نواتل،<br>به شما کمک می‌کند با اطمینان انتخاب کنید.</span>
                    </h2>
                    <p class="text-body1-semibold text-gray-400 my-5 max-w-140">صدای مشتریانی که قبل از شما این مسیر را طی کرده‌اند.</p>
                    <div class="relative mt-14">
                        <IconsCurvedArrow 
                            class="absolute bottom-0 lg:top-5 lg:bottom-auto -left-5 min-[375px]:left-auto min-[375px]:right-46 lg:right-50 
                                -rotate-90 lg:-rotate-145 text-secondary-600" 
                        />
                        <div class="flex flex-col lg:flex-row gap-6 lg:gap-20 mb-10">
                            <div>
                                <span class="h3 block">37%+</span>
                                <p class="text-body1 text-gray-400">افزایش نرخ پاسخ‌گویی مشتریان</p>
                            </div>
                            <div>
                                <span class="h3 block">61%+</span>
                                <p class="text-body1 text-gray-400">کاهش میانگین صف انتظار تماس</p>
                            </div>
                        </div>
                        <Button
                            :append-icon="{ name: 'solar:round-alt-arrow-left-bold' }"
                            size="Large"
                            pill
                            @click="handleOpenModal"
                        >
                            درخواست مشاوره رایگان
                        </Button>
                    </div>
                </div>
            </div>
            <DevicesMobile class="w-full overflow-hidden">
                <div class="w-full overflow-y-hidden no-scrollbar h-103 bg-gray-100/15 mt-10 pl-10">
                    <div class="w-max h-full relative top-0 right-0 flex items-center gap-4">
                        <div 
                            v-for="comment in data"
                            :key="comment.name"
                            class="w-80 bg-linear-to-b from-white to-gray-200/20 p-1.5 rounded-3xl shadow-gray-xxs h-full"
                        >
                            <div class="w-full h-full border border-gray-200 rounded-[20px] pt-10.5 px-7.5 pb-8 bg-white">
                                <div class="w-full flex items-center justify-between">
                                    <div>
                                        <span class="text-body1-semibold text-gray-500">{{ comment.name }}</span>
                                        <span class="text-body2 text-gray-400 block">{{ comment.role }}</span>
                                    </div>
                                    <NuxtImg 
                                        :src="comment.img"
                                        :alt="comment.name"
                                        class="w-14 h-14 object-cover rounded-full border border-gray-300"
                                        loading="lazy"
                                    />
                                </div>
                                <div class="w-full flex flex-col gap-3 mt-3 divide-y divide-dashed divide-gray-300">
                                    <p class="text-body2 text-gray-500 pb-5">{{ comment.desc }}</p>
                                    <div class="w-full flex items-center divide-x divide-gray-300">
                                        <div class="w-full flex flex-col lg:flex-row gap-1">
                                            <span class="text-gray-400 text-body2 min-w-fit">محصول مورد استفاده:</span>
                                            <p class="text-body2-semibold">{{ comment.product }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
            </DevicesMobile>

            <DevicesDesktop>
                <div class="w-full flex flex-col items-center gap-3 overflow-x-hidden mr-auto">
                    <div 
                        v-for="comment in data"
                        :key="comment.name"
                        class="w-140 bg-linear-to-b from-white to-gray-200/20 p-1.5 rounded-3xl shadow-gray-xxs"
                        data-aos="fade-right"
                        data-aos-duration="1000"
                    >
                        <div class="w-full border border-gray-200 rounded-[20px] px-7.5 py-10.5 bg-white">
                            <div class="w-full flex items-center justify-between">
                                <div>
                                    <span class="text-body1-semibold text-gray-500">{{ comment.name }}</span>
                                    <span class="text-body2 text-gray-400 block">{{ comment.role }}</span>
                                </div>
                                <NuxtImg 
                                    :src="comment.img"
                                    :alt="comment.name"
                                    class="w-17 h-17 object-cover rounded-full border border-gray-300"
                                    loading="lazy"
                                />
                            </div>
                            <div class="w-full flex flex-col gap-3 mt-3 divide-y divide-dashed divide-gray-300">
                                <p class="text-body2 text-gray-500 pb-3 leading-6!">{{ comment.desc }}</p>
                                <div class="w-full flex items-center divide-x divide-gray-300">
                                    <div class="w-full flex gap-3">
                                        <span class="text-gray-400 text-body2 min-w-fit">محصول مورد استفاده:</span>
                                        <p class="text-body2-semibold -mt-0.5">{{ comment.product }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </DevicesDesktop>
        </div>
    </SectionsBase>
</template>